export default {
  "numberLabel": "_numberLabel_x74m3_1",
  "badge": "_badge_x74m3_5",
  "xsmall": "_xsmall_x74m3_25",
  "small": "_small_x74m3_26",
  "medium": "_medium_x74m3_27",
  "thin": "_thin_x74m3_47",
  "fixedSize": "_fixedSize_x74m3_72",
  "primary": "_primary_x74m3_94",
  "secondary": "_secondary_x74m3_99",
  "info": "_info_x74m3_105",
  "danger": "_danger_x74m3_111",
  "warning": "_warning_x74m3_117",
  "merge": "_merge_x74m3_123",
  "ultimate": "_ultimate_x74m3_129",
  "upgrade": "_upgrade_x74m3_138",
  "success": "_success_x74m3_144",
  "alpha": "_alpha_x74m3_150",
  "beta": "_beta_x74m3_156",
  "inverted": "_inverted_x74m3_162"
};import "ni:sha-256;NbIknWkUCapQJWUymjD67Exr4Aau2PAMcMf_hC7tmhE";